import {
  MessageBar,
  MessageBarBody,
  MessageBarTitle,
  makeStyles,
} from '@fluentui/react-components';
import { useTeams } from '../teams/TeamsProvider';

const useStyles = makeStyles({
  banner: { marginBottom: '16px' },
});

/**
 * Wireframe sheet S3b — "Open this app inside Microsoft Teams" when the tab
 * is loaded in a plain browser rather than the Teams webview. Before this,
 * `inTeams` (computed in `TeamsProvider`) was consumed by nothing (#154) —
 * every real user opens the app inside Teams, so `inTeams` is true and this
 * renders nothing there; a plain-browser visit (someone pasting the tab's
 * URL, or a dev pointing at it directly) is the only case it exists for.
 *
 * SSO (`microsoftTeams.authentication.getAuthToken()`) only works inside the
 * Teams webview, so outside it every API call fails anyway — this banner is
 * what tells a non-technical visitor *why*, instead of leaving them to read
 * an E3/401 error with no obvious next step.
 */
export function OpenInTeamsBanner() {
  const styles = useStyles();
  const { inTeams } = useTeams();

  if (inTeams) return null;

  return (
    <MessageBar intent="warning" className={styles.banner}>
      <MessageBarBody>
        <MessageBarTitle>Open this app inside Microsoft Teams</MessageBarTitle>
        This tab only works when it is opened from Teams — sign-in and every request depend on it.
      </MessageBarBody>
    </MessageBar>
  );
}
